import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './card.module.scss';


export function CardFooter ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={ cn(styles.footer, className) }
            data-template="card-footer"
            { ...props }
        />
    );
}
